import React from 'react';
import ModalUpsellCalculatePercentSale from "./ModalUpsellCalculatePercentSale";

function ModalUpsellProductInfo ({ product, className }) {
  const isDiscounted = product.compareAtPriceMin.value > 0 && product.compareAtPriceMin.value > product.price.value;
  const priceClass = isDiscounted ? "product-card__price--discounted" : "";
  const priceText = product.price.value === 0 ? "Free" : product.price.text


  return (
    <div className={className}>
      <a href={product.urlVendor} className="product-detail__vendor">
        {product.vendor}
      </a>
      <h4 className="product-detail__title">{product.title}</h4>
      <div
        className={`product-detail__price modal-upsell__product-price product-card__price ${priceClass}`}
      >
        {product.compareAtPriceMin.value > 0 && (
          <s>{product.compareAtPriceMin.text}</s>
        )}
        <span>{priceText}</span>
        <ModalUpsellCalculatePercentSale price={product.price.value} comparePrice={product.compareAtPriceMin.value} />
      </div>
    </div>
  );
};


export default ModalUpsellProductInfo;